<template>
  <img class="MuxVideoThumbnail" v-if="video"
    :src="`https://image.mux.com/${video.asset.playbackId}/${animated ? 'animated' : 'thumbnail'}.webp${paramStr}`"
  />
</template>

<script setup>

function toParamStr(params) {
  const keyValuePairs = Object.entries(params).map(([key, value]) => `${key}=${value}`)
  return `?${keyValuePairs.join('&')}`
}

const { video, height, animated = false, params } = defineProps({
  video: Object,
  animated: Boolean,
  params: Object,  // See https://www.mux.com/docs/guides/get-images-from-a-video for recognised params
})

const paramStr = params ? toParamStr(params) : ''
</script>
